export default __webpack_public_path__ + "static/media/bl-coupon.588ba25b.png";